/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDialogDatetime } from "../../d-dialog-datetime";
import { DThemeDarkDialogFitted } from "./d-theme-dark-dialog-fitted";

export class DThemeDarkDialogDatetime
	extends DThemeDarkDialogFitted
	implements DThemeDialogDatetime {}
